import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, featureName } from '../store/company.state';

const getState = createFeatureSelector<State>(featureName);
export const getCompany = createSelector(getState, (state) => state.company);
export const getMirasapoPlusInfo = createSelector(getState, (state) => state.mirasapoPlusInfo);
